import { getSupabaseClient } from '../supabaseClient';

/**
 * Get the account ID for the current user
 * Works for both account owners (user.id == account.id) and team members
 */
export const getUserAccountId = async () => {
  const supabase = getSupabaseClient();

  try {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error) throw error;
    if (!session) throw new Error('Not authenticated');

    const { user } = session;

    // First check if user is a team member
    const { data: teamMember } = await supabase
      .from('account_users')
      .select('account_id, role')
      .eq('user_id', user.id)
      .eq('is_active', true)
      .single();

    if (teamMember) {
      return {
        accountId: teamMember.account_id,
        role: teamMember.role,
        isTeamMember: true
      };
    }

    // Fallback: user is account owner
    return {
      accountId: user.id,
      role: 'owner',
      isTeamMember: false
    };
  } catch (error) {
    console.error('Error getting user account ID:', error);
    throw error;
  }
}; 